/* Size-guide unit toggle (cm ↔ in). Global, persisted in localStorage.
   - Captures the original cm values once per cell into data-cm-original.
   - Only converts cells whose column header contains "cm"; "kg" / sizes /
     codes are left as-is.
   - Updates header label "(cm)" → "(in)" too. */

(function () {
  const STORAGE_KEY = 'sg_unit';
  const CM_TO_IN = 0.3937008;

  const round1 = (n) => Math.round(n * 10) / 10;

  /** Parse a cell like "86-92" or "27.5" → array of numbers + a formatter. */
  function parseRange(text) {
    const trimmed = String(text).trim();
    // Match number(s) including decimals; preserve any non-numeric separators.
    const numbers = [];
    const parts = trimmed.split(/(-|–|—|\s+to\s+|\s*\/\s*)/);
    parts.forEach((p) => {
      const n = parseFloat(p);
      if (!isNaN(n) && p.trim() !== '') numbers.push(n);
    });
    return numbers;
  }

  /** Replace numeric values in a string with their converted equivalents. */
  function convertText(text, factor) {
    return String(text).replace(/(\d+(?:\.\d+)?)/g, (match) => {
      const n = parseFloat(match) * factor;
      return String(round1(n));
    });
  }

  function tagTable(wrap) {
    if (wrap.dataset.sgmUnitReady) return;
    const table = wrap.querySelector('table');
    if (!table) return;

    const headers = table.querySelectorAll('thead th, tr:first-child th');
    const cmCols = [];
    headers.forEach((h, i) => {
      const text = (h.textContent || '').toLowerCase();
      if (text.includes('cm')) {
        cmCols.push(i);
        // Save original header text for label swap.
        h.dataset.headerOriginal = h.textContent;
      }
    });

    if (!cmCols.length) {
      wrap.dataset.sgmUnitReady = '1';
      return;
    }

    // Snapshot every cm-column cell's original text.
    const rows = table.querySelectorAll('tr');
    rows.forEach((row, rIdx) => {
      if (rIdx === 0) return; // skip header row
      cmCols.forEach((c) => {
        const cell = row.children[c];
        if (cell && !cell.dataset.cmOriginal) {
          cell.dataset.cmOriginal = cell.textContent;
        }
      });
    });

    wrap.dataset.sgmUnitReady = '1';
    wrap.dataset.cmCols = cmCols.join(',');
  }

  function applyUnit(unit) {
    document.querySelectorAll('.size-guide-measurements__table-wrap').forEach((wrap) => {
      tagTable(wrap);
      const table = wrap.querySelector('table');
      if (!table) return;

      // Headers: on desktop swap "(cm)" ↔ "(in)"; on mobile drop the unit
      // suffix entirely (the toggle already shows it).
      const isMobile = window.matchMedia('(max-width: 1023px)').matches;
      table.querySelectorAll('thead th, tr:first-child th').forEach((h) => {
        const original = h.dataset.headerOriginal;
        if (!original) return;
        if (isMobile) {
          h.textContent = original.replace(/\s*\((?:cm|in)\)\s*$/i, '').trim();
        } else if (unit === 'in') {
          h.textContent = original.replace(/\(cm\)/i, '(in)');
        } else {
          h.textContent = original;
        }
      });

      // Data cells: convert if cm column.
      const cmCols = (wrap.dataset.cmCols || '').split(',').filter(Boolean).map(Number);
      if (!cmCols.length) return;

      const rows = table.querySelectorAll('tr');
      rows.forEach((row, rIdx) => {
        if (rIdx === 0) return;
        cmCols.forEach((c) => {
          const cell = row.children[c];
          const original = cell?.dataset.cmOriginal;
          if (!cell || !original) return;
          cell.textContent = unit === 'in' ? convertText(original, CM_TO_IN) : original;
        });
      });
    });

    // Sync all toggles' active state.
    document.querySelectorAll('[data-sgm-unit]').forEach((btn) => {
      const active = btn.dataset.sgmUnit === unit;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function init() {
    const stored = (() => { try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; } })();
    const initial = stored === 'in' ? 'in' : 'cm';
    // Always run applyUnit on first paint so header units are cleaned on mobile
    // (the toggle already shows the unit, headers don't need "(cm)"/"(in)").
    applyUnit(initial);

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-sgm-unit]');
      if (!btn) return;
      const unit = btn.dataset.sgmUnit === 'in' ? 'in' : 'cm';
      try { localStorage.setItem(STORAGE_KEY, unit); } catch (err) { /* ignore */ }
      applyUnit(unit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
